<template>
  <Banner v-bind="$attrs" compact>
    <template #afterHeading>
      <GiftcardBuyBox class="md:mt-3 md:mb-6 w-full lg:pr-14" />
    </template>
  </Banner>
</template>

<script setup lang="ts">
// Giftcard variant of the generic Banner: keeps the tighter (compact) spacing
// and mounts the GiftcardBuyBox below the heading. All banner props/attrs are
// forwarded straight through to Banner.
defineOptions({ inheritAttrs: false })
</script>
